import * as types from './types';

const INITIAL_STATE = {
  loading: true,
  userSettings: {
    isExpandMenuRight: true,
    lastPage: [],
    filter_list: [],
    viewPortList: [],
  },
  refreshKey: null,
};

export default (state = INITIAL_STATE, action) => {
  if (action.type.includes('__FETCHING')) return { ...state, loading: true };
  if (action.type.includes('__FAIL')) return { ...state, loading: false };
  if (action.type.includes('__FINISHED')) return { ...state, loading: false };
  switch (action.type) {
    case types.INITIAL:
      return { ...state };
    case types.SET_REFRESH_KEY:
      return {
        ...state,
        refreshKey: action.payload,
      };
    case types.GET_USER_SETTINGS:
      return {
        ...state,
        userSettings: { ...state.userSettings, ...action.payload },
      };
    default:
      return state;
  }
};
